import okIcon from "./ok-button.svg";
import noIcon from "./no-button.svg";
import homeIcon from "./home-icon.svg";
import chatIcon from "./chat-icon.svg";
import voiceIcon from "./voice-icon.svg";
import createIcon from "./create-icon.svg";
import enrollIcon from "./enroll-icon.svg";
import friendIcon from "./friend-icon.svg";
import enrollLoading from "./enroll-loading.svg";
import inputClearButton from "./input-clear-button.svg";
import checkIcon from "./check-icon.svg";
import emptyCheckIcon from "./empty-check-icon.svg";
import greenCheckIcon from "./green-check-icon.svg";
import groupIcon from "./group-icon.svg";
import profileIcon from "./profile-icon.png";
import startPage from "./temp-bg-1.png";
import meetingBackground from "./temp_bg-2.png";
import signUpPage from "./temp-bg-3.png";
import logoIcon from "./logo.svg";
import doubleLogoIcon from "./double-logo.svg";
import gradientLogoIcon from "./gradient-logo.png";
import gradientDoubleLogoIcon from "./gradient-double-logo.svg";
import reverseTriangle from "./reverse-triangle.svg";
import bgImg1 from "./bg-img-1.svg";
import bgImg2 from "./bg-img-2.svg";
import bgImg3 from "./bg-img-3.svg";
import bgImg4 from "./bg-img-4.svg";
import originalBgImg1 from "./original-bg-img-1.svg";
import originalBgImg2 from "./original-bg-img-2.svg";
import originalBgImg3 from "./original-bg-img-3.svg";
import OnButton from "./onButton.svg";
import OffButton from "./offButton.svg";
import originalBgImg4 from "./original-bg-img-4.svg";

const Images = {
  chatIcon,
  createIcon,
  enrollIcon,
  friendIcon,
  homeIcon,
  profileIcon,
  voiceIcon,
  enrollLoading,
  inputClearButton,
  noIcon,
  okIcon,
  signUpPage,
  checkIcon,
  emptyCheckIcon,
  groupIcon,
  meetingBackground,
  greenCheckIcon,
  startPage,
  logoIcon,
  doubleLogoIcon,
  reverseTriangle,
  gradientLogoIcon,
  gradientDoubleLogoIcon,
  bgImg1,
  bgImg2,
  bgImg3,
  bgImg4,
  originalBgImg1,
  originalBgImg2,
  originalBgImg3,
  originalBgImg4,
  OnButton,
  OffButton,
};

export default Images;
